export function Hero() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="hero">
      <div className="hero__bg-grid" aria-hidden="true" />
      <div className="hero__content">
        <p className="hero__eyebrow">Trusted since 2018</p>
        <h1 className="hero__headline">
          Financial clarity,<br />
          <em>built on trust.</em>
        </h1>
        <p className="hero__sub">
          We bring precision, integrity, and deep expertise to help
          individuals and businesses navigate their financial futures with confidence.
        </p>
        <div className="hero__actions">
          <button className="btn btn--primary" onClick={() => scrollTo('contact')}>
            Book a Consultation
          </button>
          <button className="btn btn--ghost" onClick={() => scrollTo('services')}>
            Our Services
          </button>
        </div>
      </div>
      <div className="hero__stats">
        <div className="hero__stat">
          <span className="hero__stat-num">8+</span>
          <span className="hero__stat-label">Years of Practice</span>
        </div>
        <div className="hero__stat-divider" />
        <div className="hero__stat">
          <span className="hero__stat-num">500+</span>
          <span className="hero__stat-label">Clients Served</span>
        </div>
      </div>
    </section>
  );
}
